import { STORAGE_URL } from "constants";
import { useFetch, useLanguage } from "hooks";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import DocumentModal from "./DocumentModal";
import PDF_MODAL from "./PDF_MODAL";

/**
 * this page book_id, link_id from url and get book details and look for the book link with link_id id and show this link on its type
 */

const videoTypes = ["mp4", "webm", "ogv", "ogg"]; // types of video that we can handel
const audioTypes = ["mp3", "wav", "ogg"]; // types of audio that we can handel

export default function ShowLink() {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const [bookDetailsResponse, bookDetailsRequest] = useFetch(`getBookDetails`); //to get Book Details that contain the link
  const bookData = bookDetailsResponse.result.data;
  const { book_id, link_id } = useParams(); // params values
  const [link, setLink] = React.useState(null);
  const navigate = useNavigate();

  const [video, setVideo] = React.useState();
  const [videoType, setVideoType] = React.useState();

  const [audio, setAudio] = React.useState();
  const [audioType, setAudioType] = React.useState();
  const [pdfDocument, setPDFDocument] = React.useState(null);
  const [document, setDocument] = React.useState(null);

  const [_, viewBookLinkRequest] = useFetch(`User/viewBookLink`, "POST");

  const onView = React.useCallback(
    (id) => {
      viewBookLinkRequest({
        book_link_id: id,
        book_id: Number(book_id),
      });
    },
    [viewBookLinkRequest, book_id]
  ); // when you view the book link we sent this request to let the Back end know that you view this (for profile History)

  React.useEffect(() => {
    if (book_id && typeof parseInt(book_id) === "number") {
      bookDetailsRequest(null, `?book_id=${book_id}`);
    }
  }, [bookDetailsRequest, book_id]);

  React.useEffect(() => {
    if (bookDetailsResponse.result.data?.details) {
      const { links } = bookDetailsResponse.result.data.details;
      let link = links.filter((item) => Number(item.id) === Number(link_id));
      if (link.length > 0) setLink(link[0]);
    }
  }, [bookDetailsResponse.result.data, link_id]);

  React.useEffect(() => {
    if (link?.link) {
      onView(link.id);
      let fileType = link.link.split(".").pop();
      fileType = fileType.toLowerCase();
      //we don't approves on the link type because the admin may select a wrong we just use it in ogg because it can play without error in both cases video or audio
      if (
        videoTypes.includes(fileType) &&
        !(
          fileType === "ogg" &&
          (link.type?.type.includes("audio") ||
            link.type?.type.includes("سمعي"))
        )// if you enter audio in type ogg the code gonna handel it as a video that why we add this condition (link.type?.type.includes("audio") || link.type?.type.includes("سمعي")) 
      ) {
        setVideo(link.link);
        setVideoType(fileType);
      } else if (audioTypes.includes(fileType)) {
        setAudio(link.link);
        setAudioType(fileType);
      } else if (fileType === "pdf") setPDFDocument(link);
      else setDocument(link);
    }
  }, [link, onView]);

  return (
    <div id="show-link-page" className="p-5">
      <Row>
        <Col xs={12} className="mb-3">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h3 className="text-primary">{link?.type?.name}</h3>
            </div>
            <div>
              <button
                onClick={() => navigate(`/book/${book_id}`)}
                className={`btn btn-outline-primary `}
              >
                {language.back}
              </button>
            </div>
          </div>
        </Col>
        <Col xs={12}>
          {link?.link && (
            <div className="link-container">
              {audio && (
                <div className="position-relative h-100">
                  <div className="text-center h-100 p-4">
                    <img
                      src={`${STORAGE_URL}${
                        link?.cover_image || bookData?.details?.cover_image
                      }`}
                      title={`figure`}
                      alt={`figure`}
                      className="h-100"
                    />
                  </div>
                  <div className="position-absolute bottom bottom-0 w-100 py-3 px-4">
                    <audio controls autoPlay className="w-100">
                      <source
                        src={`${STORAGE_URL}${audio}`}
                        type={`audio/${audioType}`}
                      />
                    </audio>
                  </div>
                </div>
              )}

              {video && (
                <div className="w-100 h-100 p-5">
                  <video controls autoPlay className="w-100 h-100">
                    <source
                      src={`${STORAGE_URL}${video}`}
                      type={`video/${videoType}`}
                    />
                  </video>
                </div>
              )}

              {pdfDocument && (
                <PDF_MODAL
                  document={pdfDocument}
                  setDocument={(x) => {
                    setPDFDocument(x);
                    setLink(x);
                  }}
                />
              )}
              
              {document && (
                <DocumentModal
                  document={document}
                  setDocument={(x) => {
                    setDocument(x);
                    setLink(x);
                  }}
                />
              )}
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
}
